import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { featureFlagGuard } from '../core/feature-flags/feature-flag-guard';
import { CanDeactivateGuard } from '../core/guards/can-deactivate.guard';
import { Features } from '../core/feature-flags/features';
import { DigitalPublicationContentFormComponent } from './components/digital-publication-content-form/digital-publication-content-form.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: 'new', pathMatch: 'full' },
      {
        path: 'new',
        component: DigitalPublicationContentFormComponent,
        canActivate: [
          featureFlagGuard(
            Features.DIGITAL_PUBLICATION,
            true,
            '/#/content/create/4'
          ),
        ],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: ':id',
        pathMatch: 'full',
        component: DigitalPublicationContentFormComponent,
        canActivate: [
          featureFlagGuard(
            Features.DIGITAL_PUBLICATION,
            true,
            '/#/content/:id'
          ),
        ],
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: ':id/edit',
        component: DigitalPublicationContentFormComponent,
        canActivate: [
          featureFlagGuard(
            Features.DIGITAL_PUBLICATION,
            true,
            '/#/content/:id'
          ),
        ],
        canDeactivate: [CanDeactivateGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DigitalPublicationContentRoutingModule {}
